<template>
  <el-dialog
    :title="selectedItemId === null ? '新增資料夾' : '重新命名'"
    :visible.sync="innerVisible"
  >
    <el-form :model="form" ref="form" :rules="rules" @submit.native.prevent="submit">
      <el-form-item
        :label="isFolder ? '資料夾名稱' : '檔案名稱'"
        :label-width="formLabelWidth"
        prop="name"
      >
        <el-input
          v-model="form.name"
          ref="nameinput"
          autocomplete="off"
        ></el-input>
         </el-form-item>
      <el-form-item
        label="備註"
        :label-width="formLabelWidth"
        prop="description"
      >
        <el-input
          v-model="form.description"
          ref="descriptioninput"
          autocomplete="off"
          maxlength="255"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">確 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from "@/api/";
export default {
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    parentId: {
      type: Number,
      default: null,
    },
    isFolder: {
      type: Boolean,
      default: true,
    },
    selectedItemId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (value === "" && this.selectedItemId == null) {
        callback(new Error("請輸入資料夾名稱"));
      } else {
        let params;
        if (!this.selectedItemId) {
          params = {
            parent: this.parentId,
            name: value,
            isLeaf: false,
          };
        } else {
          params = {
            id: this.selectedItemId,
            name: value,
            isLeaf: !this.isFolder,
          };
        }
        API.asset
          .validateName(params)
          .then(res => {
            if (!res.data) {
              callback();
            } else {
              callback(new Error("該項目名稱已存在"));
            }
          })
          .catch(err => {
            callback(new Error(`伺服器錯誤:${err}`));
          });
      }
    };
    return {
      isLoading: false,
      rules: {
        name: [
          //{ required: true, message: "請輸入資料夾名稱", trigger: "blur" },
          { validator: validateName, trigger: "blur" },
        ],
      },
      formLabelWidth: "100px",
      form: {
        name: "",
        description: ""
      },
    };
  },
  created() {
    if (this.innerVisible) {
      if (this.selectedItemId !== null) {
        this.isLoading = true;
        API.asset
          .getAsset(this.selectedItemId)
          .then(res => {
            this.form.id = res.data.id;
            this.form.name = res.data.name;
            this.form.description = res.data.description;
          })
          .catch(err => {
            this.isLoading = false;
            this.$alert(`資料取得發生錯誤：${err}`, "系統錯誤", {
              confirmButtonText: "確定",
              callback: () => {
                this.innerVisible = false;
              },
            });
          });
      } else {
        this.form.parentId = this.parentId;
      }
    }
  },
  mounted() {
    if (this.innerVisible) {
      this.$nextTick(() => {
        this.$refs.nameinput.focus();
      });
    }
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.selectedItemId !== null) {
            this.submitUpdate();
          } else {
            this.submitAdd();
          }
        } else {
          return false;
        }
      });
    },
    submitAdd() {
      API.asset.createFolder(this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("asset/getAssetContent", null);
      });
    },
    submitUpdate() {
      API.asset.renameAsset(this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("asset/getAssetContent", null);
      });
    },
  },
};
</script>

<style></style>
